<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=600 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('create_segment') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider
    v-card-text.pt-8.pb-16.primary--text
      .text-lg.font-medium.mb-4 {{ $t('create_segment_desc_1') }}:
      .text-md.mb-8 {{ $t('create_segment_desc_2') }}
      v-item-group(mandatory @change="onChanged" flat)
        div(v-for="option in options" :key="option.id")
          v-item(v-slot="{ active, toggle }")
            .round-xl.mt-4.pa-4(:style="active ? activeStyle : inactiveStyle" @click="toggle" flat rounded="lg")
              .text-lg.font-medium.mb-1 {{ option.title }}
              .text-sm.neutral500--text {{ option.description }}
    v-divider
    v-card-actions.px-6.py-4
      v-spacer
      v-btn.button-md.neutral500--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md(@click="createSegment" :disabled="!selectedOption" color="info" depressed)
        eva-icon.mr-1.mt-1.ml-n2(name="chevron-right" width="24" height="24" fill="white")
        span {{ $t('confirm') }}
</template>

<script>
export default {
  props: ['open', 'os'],
  data: () => ({
    selectedOption: null,
    options: [
      { id: 'customer', title: 'Customers list', description: 'Choose customers from your existing customer’s list' },
      { id: 'csv', title: 'Upload CSV', description: 'Import your customers by uploading the completed csv. file template' }
    ],
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid #C1C1C1',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    }
  }),
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    onChanged (i) {
      this.selectedOption = this.options[i]
    },
    createSegment () {
      switch (this.selectedOption.id) {
        case 'customer':
          this.$router.push(`/admin/${this.os}/segments/create`)
          break
        case 'csv':
          this.$router.push(`/admin/${this.os}/segments/upload-csv`)
          break
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "create_segment_desc_1": "Select your source of customers",
    "create_segment_desc_2": "Choose one and click 'Confirm'"
  },
  "id": {
    "create_segment_desc_1": "Pilih sumber pelanggan Anda",
    "create_segment_desc_2": "Pilih salah satu dan klik 'Konfirmasi'"
  }
}
</i18n>